import React, { useEffect, useState,useRef   } from "react";
import { useNavigate } from 'react-router-dom';
import { Mic, MicOff } from "lucide-react";
import { useVoiceToText } from "react-speakup";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";



import axios from "axios";
import "./DetailExam.css"; 


const DetailExam = () => {
  const navigate = useNavigate();
  var [examen, setExamen] = useState(null);
  const { id } = useParams(); 
  const [indication, setIndication] = useState("");
  const [resultat, setResultat] = useState("");
  const [conclusion, setConclusion] = useState("");
  const [activeField, setActiveField] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(null);
  const lastTranscriptRef = useRef("");
  const [isListening, setIsListening] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [examens, setExamens] = useState([]); 

  const { startListening, stopListening, transcript } = useVoiceToText({

    lang: "fr-FR",
  });


  const handleStart = () => {
    startListening();
    setIsListening(true);
  };
  
  const handleStop = () => {
    stopListening();
    setIsListening(false);
  };

const indicationRef = React.useRef(null);
const resultatRef = React.useRef(null);
const conclusionRef = React.useRef(null);

const handleRefresh = () => {
  fetchExamen();
};


useEffect(() => {
  const newTranscript = transcript.replace(lastTranscriptRef.current, "").trim();

  if (newTranscript && activeField && cursorPosition !== null) {
    const insertAtCursor = (text, insertText, position) =>
      text.slice(0, position) + insertText + text.slice(position);

    switch (activeField) {
      case "indication":
        setIndication((prev) => {
          const updated = insertAtCursor(prev, newTranscript, cursorPosition);
          setCursorPosition(cursorPosition + newTranscript.length);
          return updated;
        });
        break;
      case "resultat":
        setResultat((prev) => {
          const updated = insertAtCursor(prev, newTranscript, cursorPosition);
          setCursorPosition(cursorPosition + newTranscript.length);
          return updated;
        });
        break;
      case "conclusion":
        setConclusion((prev) => {
          const updated = insertAtCursor(prev, newTranscript, cursorPosition);
          setCursorPosition(cursorPosition + newTranscript.length);
          return updated;
        });
        break;
      default:
        break;
    }

    lastTranscriptRef.current = transcript;
  }
}, [transcript]);


const fetchExamen = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = response.data;
    setExamen(data);
    setIndication(data.indication || "");
    setResultat(data.resultat || "");
    setConclusion(data.conclusion || "");
  } catch (error) {
    console.error("Erreur lors de la récupération des détails :", error);
  }
};

useEffect(() => {
  if (id) {
    fetchExamen();
  }
}, [id]);

useEffect(() => {
  const fetchExamens = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen_patient/${examen?.patient?.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setExamens(response.data); // Récupérer la liste des examens
    } catch (error) {
      console.error("Erreur lors de la récupération des examens :", error);
     
    }
  };

  // Vérifier si examen.patient.id existe avant d'exécuter fetchExamens
  if (examen?.patient?.id) {
    fetchExamens();
  }
}, [examen?.patient?.id]);



  const openOHIFViewer = (examId) => {
    console.log(id);
    const url = process.env.REACT_APP_VIEWER_URL+`/viewer/${examId}`;
    const windowFeatures = "width=800,height=600,resizable,scrollbars=yes";
    const newWindow = window.open(url, "_blank", windowFeatures);
  console.log(examId);
    if (newWindow) {
      newWindow.focus();
    } else {
      alert("La fenêtre pop-up a été bloquée par votre navigateur.");
    }
  };

const handleSave = async (statut) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(
      process.env.REACT_APP_EUREKA_PACS_URL + `/api/examen/${id}`,
      {
        indication,
        resultat,
        conclusion,
        statut,
        idRadiologue: 1,
        filePath: [],
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Commentaire mis à jour avec succès", response.data);
    setShowPopup(true); 
  } catch (error) {
    console.error("Erreur lors de la mise à jour du commentaire :", error);
  }
};


  function calculerAge(dateNaissanceStr) {
    if (!dateNaissanceStr) return null;
    const naissance = new Date(dateNaissanceStr);
    const maintenant = new Date();
  
    let age = maintenant.getFullYear() - naissance.getFullYear();
    const m = maintenant.getMonth() - naissance.getMonth();
    if (m < 0 || (m === 0 && maintenant.getDate() < naissance.getDate())) {
      age--;
    }
    return age;
  }

  if (!examen) {
    return <p>Chargement des détails de l'examen...</p>;
  }
  return (
    <div className="container">
      <div className="box">
     
      <div className="buttons">
       <button onClick={() => navigate('/accueil')}>
       <span role="img" aria-label="acceuil">🏠</span>Retour à l’accueil
      </button>
      
      <button className="btn btn-blue" onClick={handleRefresh}>
        <span role="img" aria-label="Actualiser">🔄</span>Actualiser
      </button>

      <button className="btn btn-green">
      <Link to={`/rapport/${examen.id}`} >
        <span role="img" aria-label="Générer">⚙️</span> Générer le rapport
       </Link>
      </button>

      <button className="btn btn-purple" onClick={() => openOHIFViewer(examen.dicom[0].study)}>
        <span role="img" aria-label="Visualiser">👁️</span> Visualiser les images
      </button>
      
      <button className="btn-validate"  onClick={() => handleSave("TERMINE")} >
        <span role="img" aria-label="Visualiser">✅</span> Valider l'examen
      </button>

      </div>
     
      <div className="section-dest" >
        <h2>EXAMEN</h2>
        <div className="info-item"><strong>ID:</strong> {examen.id}</div>
        <div className="info-item"><strong>Libellé :</strong> {examen.nom}</div>
        <div className="info-item"><strong>Type:</strong> {examen.type}</div>
        <div className="info-item">
          <strong>Date:</strong> {examen.created_at ? new Date(examen.created_at).toLocaleDateString() : ""}
        </div>
        <div className="info-item"><strong>Statut:</strong>   {examen.statut === "TERMINE"
                                                                                ? "Terminé"
                                                                                : examen.statut === "AVEC_CR"
                                                                                ? "Avec CR"
                                                                                : "Sans CR"}</div>
        <div className="info-item"><strong>Criticité:</strong> {examen.criticite}</div>
      </div>

      <div className="section-dest" >
        <h2> PATIENT</h2>
        <div className="info-item"><strong>Nom:</strong> {examen.patient.personne?.nom}</div>
        <div className="info-item"><strong>Prenom:</strong> {examen.patient.personne?.prenom}</div>
        <div className="info-item"><strong>Age:</strong> {calculerAge(examen.patient.personne?.date_naissance)} ans</div>
        <div className="info-item"><strong>Sexe:</strong> {examen.patient.personne?.sexe}</div>
      </div>

      <div className="section-dest">
        <h2>Radiologues</h2>
        <div className="info-item"><strong> Prescripteur :</strong> Dr. ROBERRT Pierre</div>
         <div className="info-item"><strong> Destinataire:</strong> Dr. HISROC herve</div>
      </div>

      <div className="section-dest">
        <h2>Autres</h2>
         <div className="info-item"><strong> Machine :</strong> Siemens Healthineers</div>
        
      </div>
      <div className="section-histo">
        <h2>Historique du Patient</h2>
        <div className="table-container">
          <table className="histo-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Libellé</th>
                <th>Nature</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {examens.map((examen) => (
                <tr key={examen.id}>
                  <td>{examen.created_at
                            ? new Date(examen.created_at).toLocaleDateString()
                            : ""}</td>
                  <td>{examen.type}</td>
                  <td>{examen.nom}</td>
                  <td>{examen.statut === "TERMINE"
                                        ? "Terminé"
                                        : examen.statut === "AVEC_CR"
                                        ? "Avec CR"
                                        : "Sans CR"}</td>
                              
                  <td className="actions">
                     <img src="/info.png" alt="info" className="icon profil" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      </div>

      <div className="box">
        <div className="header">
          <h2>Édition du rapport</h2>
          <button className="save-button" onClick={() => handleSave("AVEC_CR")}>Sauvegarder</button>
        </div>
        <div className="flex justify-center items-center h-screen gap-x-6">
          <Mic
            onClick={handleStart}
            role="button"
            size={40}
            color={isListening ? "red" : "gray"}
            style={{ cursor: "pointer" }}
          />
          <MicOff
            onClick={handleStop}
            role="button"
            size={40}
            color={!isListening ? "black" : "gray"}
            style={{ cursor: "pointer" }}
          />
        </div>
        <label htmlFor="indication">Indication</label>
        <textarea
          ref={indicationRef}
          id="indication"
          name="indication"
          value={indication}
          onFocus={() => setActiveField("indication")}
          onClick={(e) => setCursorPosition(e.target.selectionStart)}
          onChange={(e) => {
            setIndication(e.target.value);
            setCursorPosition(e.target.selectionStart);
          }}
        ></textarea>

        <label htmlFor="resultat">Résultat</label>
        <textarea
          ref={resultatRef}
          id="resultat"
          name="resultat"
          value={resultat}
          onFocus={() => setActiveField("resultat")}
          onClick={(e) => setCursorPosition(e.target.selectionStart)}
          onChange={(e) => {
            setResultat(e.target.value);
            setCursorPosition(e.target.selectionStart);
          }}
        ></textarea>

        <label htmlFor="conclusion">Conclusion</label>
        <textarea
          ref={conclusionRef}
          id="conclusion"
          name="conclusion"
          value={conclusion}
          onFocus={() => setActiveField("conclusion")}
          onClick={(e) => setCursorPosition(e.target.selectionStart)}
          onChange={(e) => {
            setConclusion(e.target.value);
            setCursorPosition(e.target.selectionStart);
          }}
        ></textarea>
     
      </div>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>Le rapport a été sauvegardé avec succès !</p>
            <button onClick={() => setShowPopup(false)}>Fermer</button>
          </div>
        </div>
      )}

    </div>
    
  );
};

export default DetailExam;
